module.exports = __webpack_public_path__ + "static/media/grid.f87ead5d.svg";